import React, { useContext } from "react";
import PropTypes from "prop-types";
import { translate } from "react-polyglot";
import { SecondaryButton, PrimaryButton } from "../buttons";
import Modal from "../Modal";
import Text from "../edu/Text";
import { FormContext } from "../../context/form-context";

import "./FormDirtyWarningModal.css";

function FormDirtyWarningModal(props) {
  const { unSavedModalShown, hideTrackerModals, showPreviousModal, t } = props;

  const formContext = useContext(FormContext);

  const clearDirty = () => {
    formContext.notDirty();
    formContext.setValues({});
    hideTrackerModals();
  };
  return (
    <Modal
      isOpen={unSavedModalShown}
      showCloseButton={false}
      onRequestClose={clearDirty}
    >
      <h5 className="warning-modal__title">{t("tracker.unSavedModalTitle")}</h5>
      <Text className="warning-modal__text">
        {t("tracker.unSavedDescription")}
      </Text>
      <div className="warning-modal__footer">
        <PrimaryButton
          colorScheme="blue"
          label={t("tracker.cancel")}
          onClick={showPreviousModal}
        />
        <SecondaryButton
          colorScheme="red"
          label={t("tracker.confirmDiscard")}
          onClick={clearDirty}
        />
      </div>
    </Modal>
  );
}

FormDirtyWarningModal.defaultProps = {
  warningModalShown: false,
  hideTrackerModals: () => {},
  showPreviousModal: () => {},
  t: () => {}
};

FormDirtyWarningModal.propTypes = {
  warningModalShown: PropTypes.bool,
  hideTrackerModals: PropTypes.func,
  showPreviousModal: PropTypes.func,
  t: PropTypes.func
};

export default translate()(FormDirtyWarningModal);



// WEBPACK FOOTER //
// ./src/components/ActivityTracker/FormDirtyWarningModal.js